import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  display: none;
  flex-direction: column;
  gap: 24px;

  padding-block: 28px;
  padding-inline: 20px;

  color: #000000;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: normal;

  border-radius: 12px;

  background: #d4e0f2;
  font-feature-settings: "clig" off, "liga" off;

  ${props => props.theme.breakpoints.up("tablet")} {
    display: flex;
  }
`;

export const ContainerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  max-inline-size: 320px;
`;

export const Header = styled.div``;
export const Headline = styled.h2`
  font-size: 24px;
`;
export const SubHeadline = styled.div``;
export const Divider = styled.div`
  inline-size: 100%;
  block-size: 1px;

  background: #000000;
`;
export const BenefitsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  li {
    display: flex;
    flex-direction: row;
    align-items: center;
    > p {
      inline-size: 100%;
      max-inline-size: calc(100% - 60px);
      padding-inline-start: 20px;
    }
  }
`;
export const FooterMessage = styled.div``;
export const StartExploringButton = styled.button`
  padding: 12px;

  color: #ffffff;
  font-weight: 700;

  border-radius: 2px;

  background: #4585ff;

  cursor: pointer;
`;

export const Backdrop = styled.div`
  position: fixed;
  inset-block: 0 0;
  inset-inline: 0 0;
  z-index: -1;

  -webkit-tap-highlight-color: transparent;

  background: #000000;

  opacity: 0.5;
`;
